// extracted by mini-css-extract-plugin
module.exports = {"container":"CookieDisclaimer_container__h0t5C","disclaimer":"CookieDisclaimer_disclaimer__NMScJ","fadein":"CookieDisclaimer_fadein__1odZd"};